module.exports = __webpack_public_path__ + "img/002.cfbee19d.png";